import { useCallback } from 'react'
import { toast } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Button, GenericDialog } from '@/common'
import { OrganizationUser } from '@/api/OrganizationUserModel'
import { useDeleteUser } from '@/shared/hooks/api/organizationUsers'

export default function OrganizationUserDeleteDialog({
  user,
  isOpen,
  close
}: {
  user: OrganizationUser
  isOpen: boolean
  close: () => void
}) {
  const { t } = useTranslation()

  const { mutateAsync: deleteUser } = useDeleteUser()

  const onSubmitClick = useCallback(async () => {
    try {
      await deleteUser(user.id)
      toast.success(t('organizationUsers:deleteDialog.toast.success'))
      close()
    } catch {
      toast.error(t('organizationUsers:deleteDialog.toast.error'))
    }
  }, [deleteUser, user.id, t, close])

  return (
    <GenericDialog
      isOpen={isOpen}
      close={close}
      title={t('organizationUsers:deleteDialog.title')}
      size="md"
    >
      <div>
        <p className="text-sm my-2">{t('organizationUsers:deleteDialog.description')}</p>
        <div className="space-y-6 mt-4">
          <div className="gap-2 flex justify-end">
            <Button variant="neutral" onClick={close}>
              {t('organizationUsers:deleteDialog.actions.cancel')}
            </Button>
            <Button variant="danger" onClick={onSubmitClick}>
              {t('organizationUsers:deleteDialog.actions.save')}
            </Button>
          </div>
        </div>
      </div>
    </GenericDialog>
  )
}
